import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Tabs from "@mui/material/Tabs";
import { CssTabLink } from "../../styles/styled";
import {
  CssDataJacketTitleTypography,
  CssDataJacketBodyTypography,
  CssTableCellHead,
  CssStickyTableCellHead,
  CssDataJacketSubTitleTypography,
} from "../../styles/styled";
import {
  styled,
  createTheme,
  ThemeProvider,
  alpha,
} from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import Collapse from "@mui/material/Collapse";
import Link from "@mui/material/Link";
import * as React from "react";
import { API, graphqlOperation } from "aws-amplify";
import { dataset } from "../../graphql/queries";
import {
  getDataSetDetail,
  getStatisticsDetail,
  getFileHeaderItems,
  getRawDataDetail,
} from "../../js/queriesHandling";
import { Card6Statistics, Card6RawContent } from "./table";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#171717",
      sub: grey[50],
      light: grey[800],
      dark: grey[900],
      constrastText: grey[50],
      "&:hover": {
        background: "#383B3E",
      },
    },
    secondary: {
      main: grey[900],
    },
  },
});

const DataJacketItem = styled(Item)`
  ${({ theme }) => `
  //cursor: pointer;
  text-align: 'left';
  border-radius: '10px';
  background-color: ${theme.palette.primary.main};
  transition: ${theme.transitions.create(["background-color", "transform"], {
    duration: theme.transitions.duration.standard,
  })};
  `}
`;

const CssLink = styled(Link)({
  color: "#00A3E0",
});

const CssSelect = styled(Select)(({ theme }) => ({
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  color: "white",
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(228, 219, 233, 0.25)",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(228, 219, 233, 0.25)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(228, 219, 233, 0.25)",
  },
  ".MuiSvgIcon-root ": {
    fill: "white !important",
  },
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
}));
const HoverBox = styled(Box)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "#53565A",
  },
}));

export function GeneralAccordionCard({
  title,
  contents,
  titleFirst,
  titleSecond,
  titlethird,
  accordion,
}) {
  const [ActiveState, setActiveState] = React.useState(accordion);
  const toggleAccordion = () => {
    setActiveState(!ActiveState ? true : false);
  };

  function childBody(inContent) {
    let result = inContent["subcontent"];
    let result2 = "";
    let result3 = "";

    if (inContent["subcontent2"] && inContent["subcontent3"]) {
      result2 = inContent["subcontent2"];
      result3 = inContent["subcontent3"];
    }

    let sub = inContent["subchildcontent"];

    if (inContent["subchild"] === "Link") {
      if (inContent["subchildcontent"] == "-") {
        sub = (
          <CssDataJacketBodyTypography
            style={{
              marginRight: "0px",
              fontSize: "16px",
              marginLeft: "0px",
            }}
            display="inline"
          >
            {inContent["subchildcontent"]}
          </CssDataJacketBodyTypography>
        );
      } else {
        sub = (
          <CssLink
            display="inline"
            target="_blank"
            href={inContent["subchildcontent"]}
          >
            {inContent["subchildcontent"]}
          </CssLink>
        );
      }
    } else if (inContent["subchild"] === "Mail") {
      sub = (
        <CssLink
          display="inline"
          href={"mailto:" + inContent["subchildcontent"]}
        >
          {inContent["subchildcontent"]}
        </CssLink>
      );
    } else if (inContent["subchild"] === "Paragraph") {
      sub = (
        <CssDataJacketBodyTypography
          style={{
            marginLeft: "20px",
            padding: "0",
            fontSize: "16px",
          }}
        >
          {inContent["subchildcontent"]}
        </CssDataJacketBodyTypography>
      );
    }
    if (inContent["subchildcontent"] !== undefined) {
      result = (
        <CssDataJacketBodyTypography
          style={{
            whiteSpace: "nowrap",
            marginLeft: "0",
            padding: "0",
            fontSize: "16px",
            marginRight: "0",
          }}
        >
          {inContent["subcontent"]}
        </CssDataJacketBodyTypography>
      );
    }

    if (inContent["subcontent2"] && inContent["subcontent3"]) {
      return (
        <Collapse key={result} in={ActiveState}>
          <Box
            style={{
              marginLeft: "4px",
              fontSize: "16px",
              wordBreak: "break-all",
            }}
            display="flex"
            flexDirection="column"
          >
            <CssDataJacketBodyTypography
              display="inline"
              style={{
                marginLeft: "10px",
                padding: "0",
                fontSize: "16px",
                marginRight: "0",
                marginTop: "10px",
                fontWeight: "bold",
              }}
            >
              {titleFirst}
            </CssDataJacketBodyTypography>
            <CssDataJacketBodyTypography
              display="inline"
              style={{
                marginLeft: "20px",
                padding: "0",
                fontSize: "16px",
                marginRight: "0",
              }}
            >
              {result}
            </CssDataJacketBodyTypography>
            <CssDataJacketBodyTypography
              display="inline"
              style={{
                marginLeft: "10px",
                padding: "0",
                fontSize: "16px",
                marginRight: "0",
                marginTop: "20px",
                fontWeight: "bold",
              }}
            >
              {titleSecond}
            </CssDataJacketBodyTypography>
            <CssDataJacketBodyTypography
              display="inline"
              style={{
                marginLeft: "20px",
                padding: "0",
                fontSize: "16px",
                marginRight: "0",
              }}
            >
              {result2}
            </CssDataJacketBodyTypography>
            <CssDataJacketBodyTypography
              display="inline"
              style={{
                marginLeft: "10px",
                padding: "0",
                fontSize: "16px",
                marginRight: "0",
                marginTop: "20px",
                fontWeight: "bold",
              }}
            >
              {titlethird}
            </CssDataJacketBodyTypography>
            <CssDataJacketBodyTypography
              display="inline"
              style={{
                marginLeft: "20px",
                padding: "0",
                fontSize: "16px",
                marginRight: "0",
              }}
            >
              {result3}
            </CssDataJacketBodyTypography>
          </Box>
        </Collapse>
      );
    } else {
      return (
        <Collapse key={result} in={ActiveState}>
          <Box
            style={{
              marginLeft: "4px",
              fontSize: "16px",
              wordBreak: "break-all",
            }}
            display="flex"
          >
            <CssDataJacketBodyTypography
              display="inline"
              style={{
                marginLeft: "0",
                padding: "0",
                fontSize: "16px",
                marginRight: "0",
              }}
            >
              {result}
            </CssDataJacketBodyTypography>
            <CssDataJacketBodyTypography
              display="inline"
              style={{
                marginLeft: "0",
                padding: "0",
                fontSize: "16px",
                marginRight: "0",
              }}
            >
              {sub}
            </CssDataJacketBodyTypography>
          </Box>
        </Collapse>
      );
    }
  }

  return (
    <DataJacketItem
      key={title}
      style={{
        textAlign: "left",
        paddingRight: "20px",
        backgroundColor: "#303234",
        boxShadow: "none",
        borderBottom: "solid 1px white",
        borderRadius: "0",
      }}
    >
      <section id={title}>
        <Box
          style={{
            textAlign: "left",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <CssDataJacketSubTitleTypography>
            {title}
          </CssDataJacketSubTitleTypography>
          <HoverBox
            onClick={toggleAccordion}
            style={
              ActiveState
                ? {
                    display: "none",
                  }
                : {
                    borderRadius: "50%",
                    width: "45px",
                    display: "flex",
                    justifyContent: "center",
                    cursor: "pointer",
                  }
            }
          >
            <Box
              style={
                ActiveState
                  ? {
                      display: "none",
                    }
                  : {
                      width: "10px",
                      height: "10px",
                      border: "2px solid",
                      borderColor: "white white transparent transparent",
                      transform: "rotate(135deg)",

                      marginTop: "10px",
                    }
              }
            />
          </HoverBox>
        </Box>
        <Card7Accordion
          ActiveState={ActiveState}
          setActiveState={setActiveState}
        >
          {contents.map((content) => childBody(content))}
        </Card7Accordion>
      </section>
    </DataJacketItem>
  );
}

async function getDataSetDetails(inDataSet) {
  const listOfSetTitle = [];
  const listOfSetDescription = [];
  const listOfSetId = [];
  const allDataSet = { id: "", title: "", description: "" };
  await inDataSet.reduce(async (promise, item) => {
    await promise;
    const result = await API.graphql(
      graphqlOperation(dataset, { id: item })
    ).then((evt) => {
      listOfSetTitle.push(evt.data.dataset.body.dataset_title);
      listOfSetDescription.push(evt.data.dataset.body.dataset_description);
      listOfSetId.push(item);
    });
    allDataSet.id = listOfSetId;
    allDataSet.title = listOfSetTitle;
    allDataSet.description = listOfSetDescription;
  });
  return allDataSet;
}

function Card6Accordion({ arrItems, title }) {
  const dataList = [];
  const objDataId = arrItems.id;
  const objDataSetTitle = arrItems.title;
  const objDataSetDescription = arrItems.description;

  for (let i = 0; i < objDataId.length; i++) {
    if (title === objDataSetTitle[i]) {
      dataList.push(
        <ThemeProvider theme={customTheme}>
          <section id={"データセットの説明"}>
            <DataJacketItem
              style={{
                textAlign: "left",
                backgroundColor: "#303234",
                boxShadow: "none",
              }}
            >
              <CssDataJacketSubTitleTypography>
                {"データセットの説明"}
              </CssDataJacketSubTitleTypography>
              <CssDataJacketBodyTypography
                style={{
                  marginLeft: "4px",
                  fontSize: "16px",
                  wordBreak: "break-all",
                }}
              >
                {objDataSetDescription[i]}
              </CssDataJacketBodyTypography>
            </DataJacketItem>
          </section>
        </ThemeProvider>
      );
    }
  }
  return dataList;
}

export function Card6({ titles, items }) {
  const [dataList, setDataList] = React.useState([]);
  const [dataList1, setDataList1] = React.useState([]);
  const [allDataSet, setAllDataSet] = React.useState([]);
  const [displayChara, setdisplayChara] = React.useState([]);
  const [displayStatistics, setdisplayStatistics] = React.useState([]); //GRP4解放
  const [displayRawContent, setDisplayRawContent] = React.useState([]);
  const [columns, setColumns] = React.useState(0);
  const [StatisticsColumns, setStatisticsColumns] = React.useState(0);
  const [sortOrder, setSortOrder] = React.useState("");
  const [tabName, updateTabName] = React.useState("contents");
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = React.useState(true);

  let rawDataTitle = "";
  let rawDataRows = [];
  let rawDataHeader = "";

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  async function getDataSet(inDataSet) {
    if (inDataSet.length === 1 && inDataSet[0] === "") {
    } else {
      setAllDataSet(await getDataSetDetails(["9999"].concat(inDataSet)));
    }
  }

  async function changeDisplay(dataset, title) {
    setLoading(true);
    let contentRows = [];
    let newrowHeader = [];
    let statisticsRows = [];
    rawDataTitle = title;

    for (let i = 0; i < dataset.title.length; i++) {
      if (title === dataset.title[i]) {
        while (contentRows.length === 0) {
          contentRows = await getRawDataDetail(dataset.id[i]);
        }
        while (newrowHeader.length === 0) {
          newrowHeader = await getFileHeaderItems(dataset.id[i]);
        }
        while (statisticsRows.length === 0) {
          statisticsRows = await getStatisticsDetail(dataset.id[i]);
        }
        rawDataRows = contentRows;
        rawDataHeader = newrowHeader;
      }
    }
    setLoading(false);
    setDataList(
      <Card6Accordion
        key={title + "-Card6Accordion"}
        arrItems={dataset}
        title={title}
      />
    );
    setDataList1(
      <Card8Accordion
        key={title + "-Card8Accordion"}
        arrItems={dataset}
        title={title}
      />
    );
    //GRP4解放
    setdisplayStatistics(
      <Card6Statistics
        key={title + "-Statistics"}
        arrItems={dataset}
        title={title}
        setStatisticsColumns={setStatisticsColumns}
        statisticsRows={statisticsRows}
        newrowHeader={newrowHeader}
      />
    );
    setDisplayRawContent(
      <Card6RawContent
        key={title + "-Card6RawContent"}
        arrItems={dataset}
        title={title}
        setColumns={setColumns}
        setStatisticsColumns={setStatisticsColumns}
        contentRows={contentRows}
        newrowHeader={newrowHeader}
        updateContent={sortDisplayRawContent}
        sortIndex={-1}
        sortOrder={""}
      />
    );
  }

  // 生データソート処理
  let rawDataSortIndex = -1;
  let rawDataSortOrder = "";

  function sortDisplayRawContent(sortIndex) {
    rawDataSortOrder =
      rawDataSortOrder === "" ||
      rawDataSortIndex !== sortIndex ||
      (rawDataSortIndex === sortIndex && rawDataSortOrder === "DESC")
        ? "ASC"
        : "DESC";
    rawDataSortIndex = sortIndex;
    setDisplayRawContent(
      <Card6RawContent
        key={rawDataTitle + "-Card6RawContent"}
        arrItems={allDataSet}
        title={rawDataTitle}
        setColumns={setColumns}
        setStatisticsColumns={setStatisticsColumns}
        contentRows={rawDataRows}
        newrowHeader={rawDataHeader}
        updateContent={sortDisplayRawContent}
        sortIndex={sortIndex}
        sortOrder={rawDataSortOrder}
      />
    );
  }

  function tabDisplay(dataset, title) {
    switch (tabName) {
      case "contents":
        return ShowDataContentTable();
      case "explanation":
        return ShowStatistics();
      default:
        return null;
    }
  }

  function ShowDataContentTable() {
    return <>{displayRawContent}</>;
  }
  function ShowStatistics() {
    return (
      <>
        <TableHead>
          <TableRow>
            <CssStickyTableCellHead className="head">
              {"項目"}
            </CssStickyTableCellHead>
            <CssTableCellHead>{"単位"}</CssTableCellHead>
            <CssTableCellHead>{"データ型"}</CssTableCellHead>
            <CssTableCellHead>{"項目説明"}</CssTableCellHead>
            <CssTableCellHead>{"基礎統計量"}</CssTableCellHead>
          </TableRow>
        </TableHead>
        <TableBody>{displayStatistics}</TableBody>
      </>
    );
  }

  React.useEffect(() => {
    try {
      getDataSet(items.ids.split(","));
    } catch {}
  }, [items]);

  React.useEffect(() => {
    try {
      setSortOrder(allDataSet.title[0]);
      changeDisplay(allDataSet, allDataSet.title[0]);
      tabDisplay(allDataSet, allDataSet.title[0]);
      setdisplayChara(
        allDataSet.title.map((title) => (
          <MenuItem key={title + "-SelectItem"} value={title}>
            {title}
          </MenuItem>
        ))
      );
    } catch {}
  }, [allDataSet]);

  return (
    <Box>
      {loading ? (
        <Modal
          open={loading}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <ThemeProvider theme={customTheme}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh", // 画面全体の高さを基準にするために使用
              }}
            >
              <Box
                sx={{
                  border: "solid 1px #666666",
                  position: "absolute",
                  backgroundColor: "#303234",
                  display: "flex",

                  justifyContent: "center",
                  alignItems: "center",
                  width: "70%",
                  height: "200px",
                }}
              >
                <CircularProgress
                  style={{
                    color: "#505458",
                    width: "70px",
                    height: "70px",
                  }}
                />
                <CssDataJacketBodyTypography
                  display="inline"
                  style={{ fontSize: "16px" }}
                >
                  データ取得中・・・
                </CssDataJacketBodyTypography>
              </Box>
            </Box>
          </ThemeProvider>
        </Modal>
      ) : (
        <ThemeProvider theme={customTheme}>
          <section id={"データセットのタイトル"}>
            <DataJacketItem
              style={{
                textAlign: "left",
                boxShadow: "none",
                backgroundColor: "#303234",
              }}
            >
              <CssDataJacketSubTitleTypography>
                データセットのタイトル
              </CssDataJacketSubTitleTypography>
            </DataJacketItem>
            <Item
              style={{
                width: "85%",
                padding: "2px",
                marginLeft: "10px",
              }}
            >
              <FormControl
                style={{
                  backgroundColor: "#303234",
                  width: "100%",
                }}
              >
                <InputLabel
                  style={{
                    color: "white",
                  }}
                ></InputLabel>
                <CssSelect
                  variant="outlined"
                  value={sortOrder}
                  onChange={(e) => {
                    setSortOrder(e.target.value);
                    changeDisplay(allDataSet, e.target.value);
                    tabDisplay(allDataSet, e.target.value);
                  }}
                >
                  {displayChara}
                </CssSelect>
              </FormControl>
            </Item>
          </section>
          {dataList}
          <section id={"データコンテンツ・項目説明"}>
            <Tabs
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#26890D",
                  height: "3px",
                },
              }}
              value={value}
              onChange={handleChange}
            >
              <CssTabLink
                style={{ color: "white", border: "1px solid white" }}
                label="データコンテンツ"
                onClick={() => updateTabName("contents")}
              ></CssTabLink>
              <CssTabLink
                style={{
                  color: "white",
                  borderRight: "1px solid white",
                  borderTop: "1px solid white",
                  borderBottom: "1px solid white",
                }}
                label="項目説明"
                onClick={() => updateTabName("explanation")}
              ></CssTabLink>
            </Tabs>
          </section>
          <Paper
            sx={{
              overflow: "hidden",
              marginTop: "16px",
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <Box style={{ width: "100%", textAlign: "right" }}>
              <CssDataJacketBodyTypography
                style={{
                  top: 0,
                  right: 0,
                  fontSize: "16px",
                  padding: "0",
                }}
              >
                {tabName === "contents"
                  ? columns === 1
                    ? columns + " Column"
                    : columns + " / " + StatisticsColumns + " Columns"
                  : StatisticsColumns === 1
                  ? StatisticsColumns + " Column"
                  : StatisticsColumns + " Columns"}
              </CssDataJacketBodyTypography>
            </Box>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table
                stickyHeader
                aria-label="customized table"
                style={{
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
              >
                {tabDisplay()}
              </Table>
            </TableContainer>
          </Paper>
          {dataList1}
        </ThemeProvider>
      )}
    </Box>
  );
}

export function Card7Accordion({ ActiveState, setActiveState, children }) {
  const toggleAccordion = () => {
    setActiveState(!ActiveState ? true : false);
  };

  return (
    <Box className="accordionContainer">
      <Box
        className="accordionHeight"
        style={ActiveState ? {} : { display: "none" }}
      >
        {children}
      </Box>
      <Box
        sx={
          ActiveState
            ? {
                display: "flex",
                justifyContent: "flex-end",
              }
            : {}
        }
      >
        <HoverBox
          onClick={toggleAccordion}
          style={
            ActiveState
              ? {
                  borderRadius: "50%",
                  width: "45px",
                  height: "45px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }
              : {
                  display: "none",
                }
          }
        >
          <Box
            style={
              ActiveState
                ? {
                    width: "10px",
                    height: "10px",
                    border: "2px solid",
                    borderColor: "white white transparent transparent",
                    transform: "rotate(-45deg)",
                    marginTop: "5px",
                  }
                : {
                    display: "none",
                  }
            }
          ></Box>
        </HoverBox>
      </Box>
    </Box>
  );
}

function formatDatasetTarget(start, end) {
  if ((start === "" || start === "-") && (end === "" || end === "-")) {
    return "-";
  } else if (end === "" || end === "-") {
    return start;
  } else if (start === "" || start === "-") {
    return end;
  } else {
    return start + " - " + end;
  }
}

function Card8Accordion({ arrItems, title }) {
  const dataList = [];
  const objDataId = arrItems.id;
  const objDataSetTitle = arrItems.title;
  const [objDataSet, setDataSet] = React.useState([]);
  let objId = "";

  for (let i = 0; i < objDataId.length; i++) {
    if (title === objDataSetTitle[i]) {
      objId = objDataId[i];
    }
  }
  async function getDataSet() {
    setDataSet(await getDataSetDetail(objId));
  }

  try {
    React.useEffect(() => {
      getDataSet();
    }, [title]);
  } catch {}

  dataList.push(
    <>
      <GeneralAccordionCard
        key={"データコンテンツの補足情報"}
        title={"データコンテンツの補足情報"}
        contents={[
          {
            subcontent: objDataSet.dataset_additional_infomation,
          },
        ]}
        accordion={false}
      />
      <GeneralAccordionCard
        key={"データセットの対象期間"}
        title={"データセットの対象期間"}
        contents={[
          {
            subcontent: formatDatasetTarget(
              objDataSet.dataset_target_start,
              objDataSet.dataset_target_end
            ),
          },
        ]}
        accordion={false}
      />
      <GeneralAccordionCard
        key={"前処理方法"}
        title={"前処理方法"}
        contents={[
          {
            subcontent: objDataSet.dataset_preprosessing,
          },
        ]}
        accordion={false}
      />
      <GeneralAccordionCard
        key={"生データのファイル形式・アクセス権・提供頻度等に関する情報"}
        title={"生データのファイル形式・アクセス権・提供頻度等に関する情報"}
        contents={[
          {
            subcontent: "データのサイズ　　　：",
            subchildcontent: objDataSet.dataset_byte_size,
          },
          {
            subcontent: "データの保存形式　　：",
            subchildcontent: objDataSet.dataset_storage_format,
          },
          {
            subcontent: "共有条件　　　　　　：",
            subchildcontent: objDataSet.dataset_sharing_conditions,
          },
          {
            subcontent: "使用されている言語　：",
            subchildcontent: objDataSet.dataset_language,
          },
          {
            subcontent: "アクセス権　　　　　：",
            subchildcontent: objDataSet.access_right,
          },
          {
            subcontent: "提供頻度　　　　　　：",
            subchildcontent: objDataSet.dataset_provision_frequency,
          },
          {
            subcontent: "データセットの識別子：",

            subchildcontent: objDataSet.dataset_identifier,
          },
          {
            subcontent: "ソース　　　　　　　：",
            subchild: "Link",
            subchildcontent: objDataSet.source,
          },
        ]}
        accordion={false}
      />
    </>
  );

  return dataList;
}

export function CardTitle({ title }) {
  return (
    <Box key={title}>
      <CssDataJacketTitleTypography
        style={{
          marginTop: "50px",
          fontWeight: "bold",
          fontSize: "18px",
          marginLeft: "28px",
        }}
      >
        {title}
      </CssDataJacketTitleTypography>
      <Box
        style={{
          borderBottom: "solid 1.25px white",
        }}
      />
    </Box>
  );
}

export function CardContact({ organization, department }) {
  return (
    <ThemeProvider theme={customTheme}>
      <DataJacketItem
        key={"contactInfo"}
        style={{
          textAlign: "left",
          backgroundColor: "#303234",
          boxShadow: "none",
          marginBottom: "50px",
        }}
      >
        <CssDataJacketBodyTypography
          style={{
            marginLeft: "4px",
            fontSize: "16px",
            padding: "0",
          }}
        >
          <CssDataJacketBodyTypography
            style={{
              whiteSpace: "nowrap",
              marginLeft: "0",
              padding: "0",
              fontSize: "16px",
              marginRight: "0",
            }}
          >
            {"組織名　　　　：" + String(organization) + "\r\n"}
          </CssDataJacketBodyTypography>
          <CssDataJacketBodyTypography
            style={{
              whiteSpace: "nowrap",
              marginLeft: "0",
              padding: "0",
              fontSize: "16px",
              marginRight: "0",
            }}
          >
            {"担当　　　　　：" + String(department) + "\r\n"}
          </CssDataJacketBodyTypography>
          <CssDataJacketBodyTypography
            style={{
              whiteSpace: "nowrap",
              marginLeft: "0",
              padding: "0",
              fontSize: "16px",
              marginRight: "0",
            }}
          >
            {"メールアドレス："}
            <CssLink
              href={"mailto:dtcdatauniverse_usersupporttm@tohmatsu.co.jp"}
            >
              {"dtcdatauniverse_usersupporttm@tohmatsu.co.jp"}
            </CssLink>
          </CssDataJacketBodyTypography>
        </CssDataJacketBodyTypography>
      </DataJacketItem>
    </ThemeProvider>
  );
}
